import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

import { ToastContainer, toast } from 'react-toastify';

export const SaveNote = async (note) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/Notes/save`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(note),
        });

        const data = await response.json();

        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          toast.success("Note saved successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
              theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {

    console.warn("Access token is not available.");
  }

};

export const GetNotes = async (obj) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Notes/get?noteID=0&entityID=${obj.entityID}&entityType=${obj.entityType}&pageNo=${obj.pageNo}&recordsPerPage=${obj.recordsPerPage}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
        // console.log(data)

      if (response.ok && !data.isError) {
        return data // Assuming `result` is the array of linked entities
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return [];
  }
};


export const DeleteNote = async (noteID, entityID, entityType, silent="false") => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {      

        const response = await fetch(`${dev_baseUrl}/Notes/delete??noteID=${noteID}&entityID=${entityID}&entityType=${entityType}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(recordData),
        });

        const data = await response.json();

        console.log(data)

        // Handle the response format
        if (response.ok && !data.isError) {
          if(silent==="false"){
            toast.success("Note Deleted Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
               theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
              });
          }
          // Show success message from the API response
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response

          toast.error(data?.message || 'Unknown Error on notes!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error on notes!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error on notes', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {

    console.warn("Access token is not available.");
  }

};
